import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Credentials_request } from '../../../models/credentialing/credentials_request';
import { Competitor_credentials_request } from '../../../models/credentialing/competitor_credentials_request';
import { Horse_show_series } from '../../../models/horse_show_series';
import { Person } from '../../../models/person';


@Injectable({
  providedIn: 'root'
})
export class CredentialBuildingService {

  	private _credentials_request: Subject<Credentials_request> = new BehaviorSubject<Credentials_request>(new Credentials_request({}));

  	private _competitor_credentials_request: Subject<Competitor_credentials_request> = new BehaviorSubject<Competitor_credentials_request>(new Competitor_credentials_request({}));

  	private _horse_show_series: Subject<Horse_show_series> = new BehaviorSubject<Horse_show_series>(new Horse_show_series({}));

  	public horse_show_series$: Observable<Horse_show_series> = this._horse_show_series.asObservable();

  	public credentials_request$: Observable<Credentials_request> = this._credentials_request.asObservable();

  	public competitor_credentials_request$: Observable<Competitor_credentials_request> = this._competitor_credentials_request.asObservable();

	public setHorse_show_series(horse_show_series: Horse_show_series){
	  this._horse_show_series.next(horse_show_series);
	}

	public setCredentials_request(credentials_request: Credentials_request){
		this._credentials_request.next(credentials_request);
	}

	public setCompetitor_credentials_request(credentials_request: Competitor_credentials_request){
		this._competitor_credentials_request.next(credentials_request);
	}

	private _trainer: Subject<Person> = new BehaviorSubject<Person>(new Person({}));

  	public trainer$: Observable<Person> = this._trainer.asObservable();

	public setTrainer(trainer: Person){
	  this._trainer.next(trainer);
	}

	private _rider: Subject<Person> = new BehaviorSubject<Person>(new Person({}));

  	public rider$: Observable<Person> = this._rider.asObservable();

	public setRider(rider: Person){
	  this._rider.next(rider);
	}

	public reset(){
		//Leave horse show so they can you know, start again
	}


}
